import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/base";
import LoginForm from "@/components/LoginForm";
import { GoogleG, startGoogle } from "@/components/SignupSheet";
import { api } from "@/lib/api";

// REQ-1601: "Continuer avec Google" stays the primary choice, above email.
export default function LoginChoices() {
  const [cfg, setCfg] = useState({ google_auth: "oauth", emergent_auth_url: null });
  useEffect(() => { api.get("/config").then((r) => setCfg(r.data)).catch(() => {}); }, []);
  return (
    <div className="flex flex-col gap-3" data-testid="login-choices">
      <Button onClick={() => startGoogle(null, cfg, true)} className="w-full gap-2.5" data-testid="login-google-btn"><GoogleG /> Continuer avec Google</Button>
      <div className="my-1 flex items-center gap-3 text-[13px] text-muted"><span className="h-px flex-1 bg-line" />ou<span className="h-px flex-1 bg-line" /></div>
      <LoginForm />
      <p className="text-[12px] text-muted">En continuant, tu acceptes les <Link to="/conditions" className="underline underline-offset-4" data-testid="login-terms-link">conditions d'utilisation</Link>.</p>
    </div>
  );
}
